import type { Task } from '../services/api/tasksService';

export interface RoleSpecificationItem {
  text: string;
  done: boolean;
}

const cleanText = (value?: string | null): string | null => {
  const text = String(value ?? '').trim();
  return text.length > 0 ? text : null;
};

export const specificationChecklistTexts = (
  items?: Array<{ text?: string | null; done?: boolean }> | null
): string[] => {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => cleanText(item?.text))
    .filter((text): text is string => Boolean(text));
};

export const toSpecificationItems = (texts: string[]): RoleSpecificationItem[] =>
  texts.map((text) => ({ text, done: false }));

export const workerSpecificationTexts = (task: Task): string[] => {
  const workerSpec = cleanText(task.methodStatement);
  return workerSpec ? [workerSpec] : specificationChecklistTexts(task.specifications);
};

export const workerSpecificationItems = (task: Task): RoleSpecificationItem[] =>
  toSpecificationItems(workerSpecificationTexts(task));

export const supervisorSpecificationTexts = (task: Task): string[] => {
  const supervisorSpec = cleanText(task.qcSpecification);
  return supervisorSpec ? [supervisorSpec] : workerSpecificationTexts(task);
};

export const supervisorSpecificationItems = (task: Task): RoleSpecificationItem[] =>
  toSpecificationItems(supervisorSpecificationTexts(task));

export const procurementSpecificationText = (
  task?: Pick<Task, 'materialHandling'> | null
): string | null => cleanText(task?.materialHandling);
